import SuiteEnum from 'redpoints-model-js-common/enumeration/SuiteEnum';

import { ApplicationEnum } from 'redpoints-front-common/enumerations';
import {
  getEnvironment,
  getHttpSchemaWithFallback,
} from 'redpoints-front-common/helpers';

const splitedHostname = window.location.hostname.split('.');

export const ENVIRONMENT = getEnvironment();
export const APPLICATION_TOKEN = 'e0b6d2d2-2102-436f-8e7b-52f0f3aad808';
const applicationName = ApplicationEnum.FRONTOFFICE;
// Overriding application name is needed (localhost, canary, etc.).
if (splitedHostname.length === 5) {
  applicationName.url = splitedHostname[0];
}
export const APPLICATION_NAME = applicationName;
export const APPLICATION_SUITE = SuiteEnum.IPR.name;
export const VERSION = '[AIV]{version}[/AIV]';
export const SCHEME = getHttpSchemaWithFallback();
export const DEFAULT_CONTEXT_INFO = {
  applicationToken: APPLICATION_TOKEN,
  suite: APPLICATION_SUITE,
  environment: ENVIRONMENT,
  scheme: SCHEME,
};

export const BASE_URL =
  '/scopes/:scope/customers/:customerId/contracts/:contractId';

export const IMAGES = '/images';
export const LOGOS = `${IMAGES}/logos`;

export const RED_POINTS_LOGO = `${LOGOS}/red-points-ipr.svg`;

export const HOME_INFOBOXES_ENTITY = 'home_infoboxes';

export const ROUTE_PATHS = {
  HOME: 'home',
  ASSET_AUDIT_NEW_INCIDENT: 'asset-audit/new-incident',
  REPORTING_ALL_INCIDENTS: 'reporting/all-incidents',
  REPORTING_ALL_INCIDENTS_CUSTOMER: 'reporting/all-incidents-customer',
  REPORTING_INCIDENT_DETAILS: 'reporting/assets/:assetId/incidents/:incidentId',
  REPORTING_JIRA_MANAGEMENT: 'reporting/jira-management',
  NEW_INCIDENT: 'detection/new-incident',
  MANUAL_ENFORCEMENT_BY_DOMAIN: 'tasks/manual-enforcement/:domainIds?',
  ASSET_AUDIT_ASSET_VERIFICATION: 'asset-audit/asset-verification',
  ASSET_AUDIT_ASSET_VERIFICATION_DETAIL:
    'asset-audit/asset-verification/:detectionLinkId',
  ASSET_AUDIT_INFRINGEMENT_EVALUATION: 'asset-audit/infringement-evaluation',
  ASSET_AUDIT_INFRINGEMENT_EVALUATION_DETAIL:
    'asset-audit/infringement-evaluation/:detectionLinkId',
  ASSET_VERIFICATION: 'detection/asset-verification',
  ASSET_VERIFICATION_DETAIL: 'detection/asset-verification/:detectionLinkId',
  DATA_COMPLETION: 'tasks/data-completion',
  INFRINGEMENT_CONFIRMATION: 'validation/infringement-confirmation',
  INFRINGEMENT_CONFIRMATION_DETAIL:
    'validation/infringement-confirmation/:detectionLinkId',
  INFRINGEMENT_EVALUATION: 'validation/infringement-evaluation',
  INFRINGEMENT_EVALUATION_DETAIL:
    'validation/infringement-evaluation/:detectionLinkId',
  MANUAL_ENFORCEMENT: 'tasks/manual-enforcement',
  NOTICE_SENDING: 'enforcement/notice-sending',
  NOTICE_SENDING_DETAIL: 'enforcement/notice-sending/:detectionLinkId',
};

const ASSET_VERIFICATION_ROUTES = {
  ASSET_AUDIT_ASSET_VERIFICATION_DETAIL: `${BASE_URL}/${ROUTE_PATHS.ASSET_AUDIT_ASSET_VERIFICATION_DETAIL}`,
  ASSET_AUDIT_ASSET_VERIFICATION: `${BASE_URL}/${ROUTE_PATHS.ASSET_AUDIT_ASSET_VERIFICATION}`,
  ASSET_VERIFICATION_DETAIL: `${BASE_URL}/${ROUTE_PATHS.ASSET_VERIFICATION_DETAIL}`,
  ASSET_VERIFICATION_SOCIAL_MEDIA_MESSAGES: `${BASE_URL}/${ROUTE_PATHS.ASSET_VERIFICATION_DETAIL}/social-media-messages`,
  ASSET_VERIFICATION: `${BASE_URL}/${ROUTE_PATHS.ASSET_VERIFICATION}`,
};

const INFRINGEMENT_CONFIRMATION_ROUTES = {
  INFRINGEMENT_CONFIRMATION_DETAIL: `${BASE_URL}/${ROUTE_PATHS.INFRINGEMENT_CONFIRMATION_DETAIL}`,
  INFRINGEMENT_CONFIRMATION: `${BASE_URL}/${ROUTE_PATHS.INFRINGEMENT_CONFIRMATION}`,
  SOCIAL_MEDIA_MESSAGES_INFRINGEMENT_CONFIRMATION: `${BASE_URL}/${ROUTE_PATHS.INFRINGEMENT_CONFIRMATION_DETAIL}/social-media-messages`,
};

const INFRINGEMENT_EVALUATION_ROUTES = {
  ASSET_AUDIT_INFRINGEMENT_EVALUATION: `${BASE_URL}/${ROUTE_PATHS.ASSET_AUDIT_INFRINGEMENT_EVALUATION}`,
  ASSET_AUDIT_INFRINGEMENT_EVALUATION_DETAIL: `${BASE_URL}/${ROUTE_PATHS.ASSET_AUDIT_INFRINGEMENT_EVALUATION_DETAIL}`,
  INFRINGEMENT_EVALUATION: `${BASE_URL}/${ROUTE_PATHS.INFRINGEMENT_EVALUATION}`,
  INFRINGEMENT_EVALUATION_DETAIL: `${BASE_URL}/${ROUTE_PATHS.INFRINGEMENT_EVALUATION_DETAIL}`,
  INFRINGEMENT_EVALUATION_SOCIAL_MEDIA_MESSAGES: `${BASE_URL}/${ROUTE_PATHS.INFRINGEMENT_EVALUATION_DETAIL}/social-media-messages`,
};

const MANUAL_ENFORCEMENT_ROUTES = {
  MANUAL_ENFORCEMENT: `${BASE_URL}/${ROUTE_PATHS.MANUAL_ENFORCEMENT}`,
};

const NOTICE_SENDING_ROUTES = {
  NOTICE_SENDING: `${BASE_URL}/${ROUTE_PATHS.NOTICE_SENDING}`,
  NOTICE_SENDING_DETAIL: `${BASE_URL}/${ROUTE_PATHS.NOTICE_SENDING_DETAIL}`,
  NOTICE_SENDING_SOCIAL_MEDIA_MESSAGES: `${BASE_URL}/${ROUTE_PATHS.NOTICE_SENDING_DETAIL}/social-media-messages`,
  DOCUMENTS_OFFICIAL_IMAGES: `${BASE_URL}/documents/official-images`,
};

export const DEFAULT_PAGE_PATH_ON_TENANT_CHANGE = ROUTE_PATHS.HOME;

export const PAGE_PATHS_TO_REDIRECT_ON_TENANT_CHANGE = {
  [ROUTE_PATHS.ASSET_VERIFICATION_DETAIL]: ROUTE_PATHS.ASSET_VERIFICATION,
  [ROUTE_PATHS.INFRINGEMENT_EVALUATION_DETAIL]:
    ROUTE_PATHS.INFRINGEMENT_EVALUATION,
  [ROUTE_PATHS.INFRINGEMENT_CONFIRMATION_DETAIL]:
    ROUTE_PATHS.INFRINGEMENT_CONFIRMATION,
  [ROUTE_PATHS.NOTICE_SENDING_DETAIL]: ROUTE_PATHS.NOTICE_SENDING,
  [ROUTE_PATHS.REPORTING_INCIDENT_DETAILS]:
    ROUTE_PATHS.REPORTING_ALL_INCIDENTS_CUSTOMER,
  [ROUTE_PATHS.MANUAL_ENFORCEMENT_BY_DOMAIN]: ROUTE_PATHS.MANUAL_ENFORCEMENT,
};

export const ROUTES = {
  ...ASSET_VERIFICATION_ROUTES,
  ...INFRINGEMENT_CONFIRMATION_ROUTES,
  ...INFRINGEMENT_EVALUATION_ROUTES,
  ...MANUAL_ENFORCEMENT_ROUTES,
  ...NOTICE_SENDING_ROUTES,
  ASSET_AUDIT_NEW_INCIDENT: `${BASE_URL}/${ROUTE_PATHS.ASSET_AUDIT_NEW_INCIDENT}`,
  AUDIT_RESULTS: `${BASE_URL}/asset-audit/audit-results`,
  BASE: BASE_URL,
  DATA_COMPLETION: `${BASE_URL}/${ROUTE_PATHS.DATA_COMPLETION}`,
  DATA_COMPLETION_ON_HOLD: `${BASE_URL}/${ROUTE_PATHS.DATA_COMPLETION}/on-hold`,
  DATA_COMPLETION_ON_HOLD_DETAILS: `${BASE_URL}/${ROUTE_PATHS.DATA_COMPLETION}/assets/:assetId/links/:linkId/link-customers/:linkCustomerId/link-contracts/:linkContractId`,
  FACILITATOR_VALIDATION: `${BASE_URL}/tasks/facilitator-validation`,
  HOME: `${BASE_URL}/home`,
  HOME_IMPERSONATIONS: `${BASE_URL}/home-impersonations`,
  HOME_PIRACY: `${BASE_URL}/home-piracy`,
  HOME_TEST_PURCHASES: `${BASE_URL}/home-test-purchases`,
  IMAGE_RECOGNTION: `${BASE_URL}/tasks/image-recognition`,
  INCIDENTS_LIST: `${BASE_URL}/reporting/all-incidents-customer`,
  INCIDENTS_LIST_INTERNAL: `${BASE_URL}/reporting/all-incidents`,
  INCIDENT_DETAILS: `${BASE_URL}/${ROUTE_PATHS.REPORTING_INCIDENT_DETAILS}`,
  JIRA_MANAGEMENT: `${BASE_URL}/${ROUTE_PATHS.REPORTING_JIRA_MANAGEMENT}`,
  LINKS_MANAGEMENT: `${BASE_URL}/tasks/links-management`,
  LOGIN: '/',
  MANUAL_ENFORCEMENT_BY_DOMAIN: `${BASE_URL}/${ROUTE_PATHS.MANUAL_ENFORCEMENT_BY_DOMAIN}`,
  NEW_INCIDENT: `${BASE_URL}/${ROUTE_PATHS.NEW_INCIDENT}`,
  REPORTED_INCIDENTS: `${BASE_URL}/tasks/reported-incidents`,
  ROOT: '/',
  SHORTENER_RESOLUTION: `${BASE_URL}/tasks/shortener-resolution`,
  TEST_PURCHASE: `${BASE_URL}/tasks/test-purchase`,
};

export const NUM_ITEMS_PER_PAGE = 20;
export const MIN_NUMBER_CHARACTERS = 3;
export const FULFILLED = 'fulfilled';
